<script lang="ts">
    import { twMerge } from "tailwind-merge"

    let className = ""
    export { className as class }
</script>

<div class={twMerge("popup-banner", className)}>
    <slot />
</div>

<style>
    .popup-banner {
        display: grid;
        gap: 0.75rem;
        margin: -1rem -1rem 1rem;
        border-bottom: 1px solid var(--color-purple-100);
        border-radius: 1rem 1rem 0 0;
        background: var(--color-purple-50);
        padding: 1.25rem 3.25rem 1rem 1rem;
    }

    :global(.darkmode) .popup-banner {
        border-bottom-color: var(--color-grey-700);
        background: var(--color-grey-800);
    }
</style>
